const orders = {
  Title: "Orders",
  Sections: {
    OrderHistory: "Order history",
    BackOrders: "Backorders",
    ReorderProducts: "Reorder products",
  },
  BackTo: "Back to {{page}}",
  ClearSearchAdjustFilters: "Clear your search or try adjusting the filters applied.",
};

export { orders };
